<template>
  <div>
    <PageAllow controller="Shops" action="shopStockTakeOrders"/>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t("CRUD.info", [
                  mode == "regularNew"
                    ? $t("shopStockTakeOrders.regularStakeOrder")
                    : $t("shopStockTakeOrders.ObjectName"),
                ])
              }}
              <v-chip
                v-if="stockTakeOrder.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="stockTakeOrder.status | stockTakeOrderStatusColor"
                :text-color="
                  stockTakeOrder.status | stockTakeOrderStatusTextColor
                "
                >{{ stockTakeOrder.status | stockTakeOrderStatusText }}
              </v-chip>
              <span
                class="text-no-wrap caption secondary--text ml-1"
                v-if="stockTakeOrder.term_date"
              >
                ({{ $t("shopStockTakeOrders.Fields.term_date")}}{{ stockTakeOrder.term_date | formatTime }})
              </span>
              <v-spacer />
              <StockTakeOrderActions
                :stock_take_order="stockTakeOrder"
                :shop_id="this.$route.query.shop_id"
                showExport
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 盘点单编号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ stockTakeOrder.stock_take_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 仓库名称 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.stock_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("shopStockTakeOrders.default_stock_name") }}
                  </span>
                </v-card>
              </v-col>

              <!-- 创建时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 操作人 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.operater_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.create_name }}
                </v-card>
              </v-col>
              <!-- 执行人 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.execute_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{stockTakeOrder.operater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 盘点时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.stockTakeTime")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.finish_time | formatTime }}
                </v-card>
              </v-col>
              <!-- 盘点时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopStockTakeOrders.DetailFields.actual_finish_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.actual_finish_time | formatTime }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab @click.stop="tab = 0">
                {{ $t("ActivityFields.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="stock_out_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card>
        <!-- 明细/编辑 -->
        <v-data-table
          id="order_details_table"
          :headers="detailsHeaders"
          :items="stockTakeOrderDetails"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4 pb-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('shopStockTakeOrders.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("shopStockTakeOrders.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeOrderDetails.length
                        ? [
                            1,
                            stockTakeOrderDetails.length,
                            stockTakeOrderDetails.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <!-- 普通盘点的库存量 -->
          <template v-slot:item.stock_num="{ item }">
            <!-- <span v-if="$i18n.locale == 'zhHans'">
              {{ item.stock_num }}
            </span> -->
            <!-- <span v-else> -->
            <span class="text-no-wrap">
              {{ item.current_count ? item.current_count : 0 }}
            </span>
            <span
              class="text-no-wrap"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.unit }}
            </span>
          </template>
          <!-- 库存量 -->
          <template v-slot:item.sys_count="{ item }">
            {{ item.sys_count }}{{ item.unit }}
          </template>
          <template v-slot:item.current_count="{ item }">
            {{ item.current_count }}
          </template>
          <!-- 盘点量 -->
          <template v-slot:item.real_count="{ item }">
            <span> {{ item.real_count ? item.real_count : 0 }} </span>
          </template>

          <template v-slot:item.stock_take_status="{ item }">
            <v-chip
              small
              label
              class="ms-4 mt-1"
              :color="
                item.sys_count == item.real_count
                  ? 'grey'
                  : item.sys_count > item.real_count
                  ? 'danger'
                  : item.sys_count < item.real_count
                  ? 'primary'
                  : 'gray'
              "
              text-color="white"
              >{{
                $t(
                  item.sys_count == item.real_count
                    ? "shopStockTakeOrders.status.stock_take_equality"
                    : item.sys_count > item.real_count
                    ? "shopStockTakeOrders.status.stock_take_loss"
                    : item.real_count > item.sys_count
                    ? "shopStockTakeOrders.status.stock_take_profit"
                    : "Status.unkown"
                )
              }}
            </v-chip>
          </template>
          <!-- 单价 -->
          <template v-slot:item.price="{ item }">
            <span>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
          </template>
        </v-data-table>
      </v-card>

    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Shops from "@/api/shops";
import StockTakeOrderActions from "./plugins/Actions";
// import SearcherStockMaterial from "@/components/plugins/SearcherStockMaterial";
// import SearcherDatetime from "@/components/plugins/SearcherDatetime";
// import { ValidationObserver, ValidationProvider } from "vee-validate";
// import DialogAlert from "@/components/plugins/DialogAlert";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockTakeOrderActions,
    // DialogAlert,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopPsi"),
          href: "/shop-psi",
        },
        {
          text: i18n.t("Nav.shopStockTakeOrders"),
          href: "/shop-stock-take-orders",
        },
        {
          text: i18n.t("Nav.stockTakeOrderDetail"),
          disabled: true,
        },
      ];
      items.push({
        text: this.stockTakeOrder && this.stockTakeOrder.stock_take_code ? this.stockTakeOrder.stock_take_code : "",
        disabled: false,
        accent: true,
      });
      return items;
    },
    // 编辑table-header
    detailsHeaders() {
      var headers = [];
      //公共
      headers.push(
        {
          text: i18n.t("shopStockTakeOrders.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("shopStockTakeOrders.DetailFields.material"),
          align: "start",
          value: "Description",
        }
      );
      //详情或盘点时
      if (this.isView || this.mode == "stockTake") {
        headers.push({
          text: i18n.t("shopStockTakeOrders.DetailFields.unit"),
          align: "center",
          value: "unit",
        });
        if (this.stockTakeOrder.status == 2) {
          headers.push({
            text: i18n.t("shopStockTakeOrders.DetailFields.old_stock_count"),
            align: "end",
            value: "sys_count",
          });
        } else {
          headers.push({
            text: i18n.t("shopStockTakeOrders.DetailFields.current_stock_count"),
            align: "end",
            value: "sys_count",
          });
        }
        if (this.isView) {
          headers.push({
            text: i18n.t("shopStockTakeOrders.DetailFields.stock_take_count"),
            align: "center",
            value: "real_count",
          });
        }

        if (this.isView && this.stockTakeOrder.status == 2) {
          headers.push({
            text: i18n.t("shopStockTakeOrders.DetailFields.status"),
            align: "start",
            value: "stock_take_status",
          });
        }

        if (this.mode == "stockTake") {
          // if (this.$i18n.locale != "zhHans") {
          //   headers.push(
          //     {
          //       text: i18n.t(
          //         "shopStockTakeOrders.DetailFields.stock_take_count_with_stock_unit"
          //       ),
          //       align: "center",
          //       value: "real_count_rate",
          //     },
          //     {
          //       text: i18n.t(
          //         "shopStockTakeOrders.DetailFields.stock_take_count_with_default_unit"
          //       ),
          //       align: "center",
          //       value: "real_count_default",
          //     }
          //   );
          // } else {
          headers.push({
            text: i18n.t("shopStockTakeOrders.DetailFields.stock_take_count"),
            align: "center",
            value: "real_count",
            width: "220",
          });
          // }
        }
      }
      //新建
      if (this.mode == "regularNew") {
        //普通盘点
        headers.push({
          text: i18n.t("shopStockTakeOrders.DetailFields.current_stock_count"),
          align: "start",
          value: "stock_num",
        });
      }
      return headers;
    },

    material_id() {
      return this.addMaterial ? this.addMaterial.material_id : null;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountUser", "settings"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    stock_out_activities: [],
    stockTakeOrder: {},
    stockTakeOrderDetails: [],
    stock: null,
  }),

  mounted() {
    if (this.$route.path.startsWith("/stock-takes/regular-new")) {
      this.mode = "regularNew";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/stock-takes/" + this.$route.params.id);
    }
  },

  methods: {
    getStockInsFromAPI() {
      Shops.shopStockTakeOrdersDetails({
        stock_take_id: this.$route.params.id,
        shop_id: this.$route.query.shop_id,
        readonly: 1,
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockTakeOrder = response.data.stock_take;
            this.stock_out_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/stock-takes/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getStockInsFromAPI();
        }
      },
    },
    stockTakeOrder: {
      handler() {
        this.stockTakeOrderDetails =
          this.stockTakeOrder && this.stockTakeOrder.stock_take_details
            ? this.stockTakeOrder.stock_take_details
            : [];
        // this.stock =
        //   this.stockTakeOrder && this.stockTakeOrder.stock
        //     ? this.stockTakeOrder.stock
        //     : {};
      },
    },
    stockTakeOrderDetails: {
      handler() {
        this.stockTakeOrderDetails.map((detail) => {
          detail.Description = i18n.t(
            "Material.materialNameWithCodeAndStandard",
            [detail.material_code, detail.material_name, detail.standard_name]
          );
        });
      },
    },
  },
};
</script>